import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import OverallHeader from "../texts/OverallHeader";
import { PerformanceGauge } from "../charts/PerformanceGauge";
import { OverallCard } from "./OverallCard";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useOverallPerformanceCardStyles = makeThemedStyles(
  "OverallPerformanceCard",
  (theme) => ({
    divider: {
      height: "50px",
    },
  })
);

export const OverallPerformanceCard = React.memo(
  (
    props: React.PropsWithChildren<{
      element: ICardElementWithChildren;
      periodName: string;
      disableAnimation?: boolean;
      key: keyof ICardElementWithChildren;
      titleKey: keyof ICardElementWithChildren;
    }>
  ) => {
    const styles = useOverallPerformanceCardStyles();
    const { element: el } = props;
    return (
      <OverallCard>
        <OverallHeader
          title="Overall Performance"
          periodName={el.period?.name || ""}
        />
        <div className={styles.divider} />
        <div className="chart">
          <PerformanceGauge
            angleStart={-90}
            disableAnimation={props.disableAnimation}
            angleEnd={90}
            width={350}
            height={170}
            element={el!}
            valueKey={props.key}
            prettyKey={props.titleKey}
          />
        </div>
      </OverallCard>
    );
  }
);

export default OverallPerformanceCard;
